module.exports = __webpack_public_path__ + "static/goals-ef93aaca0d4ee14fb2f174461da35d48.png";